import { DIVISIONS_LIST, GROUPS_LIST, DEPARTMENTS_LIST } from 'constants/index';
import { associatePerformanceService } from 'config/api';
import { getDateParams } from 'utils';
import actionTypes from './actionTypes';

export const setPerformanceDateFilter = (payload) => ({
  type: actionTypes.PERF_SET_PERFORMANCE_DATE_FILTER,
  payload,
});

export const clearPerformanceDateFilter = () => ({
  type: actionTypes.PERF_CLEAR_PERFORMANCE_DATE_FILTER,
});

const mappingNames = (list = [], NAME_LIST) => list.map((item) => ({ ...item, value: NAME_LIST[item.key] }));

export const getPerformanceFilterOptions =
  ({ dateRange: { startDate, endDate }, associatePin, filter, filterType }) =>
  async (dispatch) => {
    const params = {
      filter,
      filterType,
      ...getDateParams({ filter: filterType, startDate, endDate, keyNames: { from: 'dateFrom', to: 'dateTo' } }),
    };

    dispatch({
      type: actionTypes.PERF_FILTER_OPTIONS_LOADING,
    });
    try {
      const { data } = await associatePerformanceService.post(`v2/data/${associatePin}/filter-options`, params);
      const payload = {
        ...data,
        divisionId: mappingNames(data.divisionId, DIVISIONS_LIST),
        groupId: mappingNames(data.groupId, GROUPS_LIST),
        departmentCode: mappingNames(data.departmentCode, DEPARTMENTS_LIST),
      };

      dispatch({
        type: actionTypes.PERF_FILTER_OPTIONS_SUCCESS,
        payload,
      });
    } catch (error) {
      dispatch({
        type: actionTypes.PERF_FILTER_OPTIONS_ERROR,
        payload: error,
      });
    }
  };
